export interface SurveyFullViewModel {
    reference: string;
    surveyRef: string;
    date: string;
    town: string;
    isATC: boolean;
    isResurvey: boolean;
    param1?: number;
    param2?: number;
    param3?: number;
    param4?: number;
    gfaNotInUse?: number;
    dayOfWeekIndex: number;
    locationId?: number;
    subLocationId?: number;
    servicingVehicles: string;
    useClass?: number;
    travelPlan?: number;
    petrolFillingStation?: string;
    pop1MileId?: number;
    pop5MileId?: number;
    car5Id?: number
    pop500?: number;
    ptpweekday0719?: number;
    ptpweekday0710?: number;
    ptpweekday1619?: number;
    ptpsaturday0719?: number;
    ptpsunday0719?: number;
    dataVersion?: string | null;
    publicTransportReasonForBlank?: string | null;
    parkingTotal?: number;
    ptal?: string;

    bedroomPerDwelling?: number;
    privatePercentage?: number;
    parkingSpacesPerDwelling?: number;

    siteOffices?: number;
    siteResearchAndDev?: number;
    siteLightIndustrial?: number;
    siteGeneralIndustrial?: number;
    siteStorageAndDistribution?: number;
    residentialUnitType: string;

    hasDetechedHouses: boolean;
    hasSemiDetechedHouses: boolean;
    hasTerracedHouses: boolean;
    hasBungalows: boolean;
    hasFlatsInHouses: boolean;
    hasFlatsInBlocks: boolean;
    hasTownHouses: boolean;

    lat?: number;
    long?: number;
    area: string;
    rawDate: Date;

    description: string;
    location: string;
    paramLabels: string[];

    regionCode: string;
    regionDescription: string;
    areaCode: string;
    areaDescription: string;
    resurveyId: string;
}

type SurveySummary = Pick<
    SurveyFullViewModel,
    | "reference"
    | "lat"
    | "long"
    | "area"
    | "description"
    | "town"
    | "location"
    | "paramLabels"
    | "param1"
    | "param2"
    | "param3"
    | "param4"
>;

export function GetDistinctSurveys(data: SurveyFullViewModel[]): SurveySummary[] {
    const seen = new Set<string>();
    const distinct: SurveySummary[] = [];

    for (const item of data) {
        const key = `${item.reference}-${item.lat}-${item.long}-${item.area}`;
        if (!seen.has(key)) {
            seen.add(key);
            distinct.push({
                reference: item.reference,
                lat: item.lat,
                long: item.long,
                area: item.area,
                description: item.description,
                town: item.town,
                location: item.location,
                paramLabels: item.paramLabels,
                param1: item.param1,
                param2: item.param2,
                param3: item.param3,
                param4: item.param4,
            });
        }
    }

    return distinct;
}

